import React from 'react';
import { Container, styled } from '@teko/ui';
import { BuildPcDesktop } from './BuildPcDesktop';
import { useTenantConfig } from 'hooks';
import { BuildPcMobile } from './BuildPcMobile';
import { HeadSection } from 'components/HeadSection';

const StyledContainer = styled(Container)`
  margin-top: 1rem;
`;

export const BuildPc: React.FunctionComponent = () => {
  const { isMobile } = useTenantConfig();

  return (
    <>
      <HeadSection
        title="Build PC - Xây dựng cấu hình máy tính"
        metaTitle="Build PC gaming, văn phòng - Xây dựng cấu hình PC giá tốt"
        description="Dịch vụ build PC xây dựng cấu hình máy chuẩn. Cấu hình gaming, đồ họa, văn phòng tối ưu, linh kiện chính hãng, giá tốt. Liên hệ ngay để được tư vấn!"
      />
      {isMobile ? (
        <BuildPcMobile />
      ) : (
        <StyledContainer>
          <BuildPcDesktop />
        </StyledContainer>
      )}
    </>
  );
};
